import {
	ChangeDetectionStrategy,
	Component,
	Inject,
	OnInit,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FolderBreadcrumbs } from '@core/util/folder';
import { Folder } from '@models/matter';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import { MergedMatterFolderSelectors } from '@state/global/documents/merged-folders';

export interface FolderDialogData {
	folder: Folder;
}
export type FolderDialogClose = Folder;

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'app-delete-folder-dialog',
	templateUrl: 'folder-delete-dialog.component.html',
	standalone: false,
})
export class FolderDeleteDialogComponent implements OnInit {
	breadcrumbs: Folder[];
	@SelectSnapshot(MergedMatterFolderSelectors.getAll) folders: Folder[];

	constructor(
		@Inject(MAT_DIALOG_DATA) public data: FolderDialogData,
		private dialogRef: MatDialogRef<FolderDeleteDialogComponent>,
	) {}

	ngOnInit(): void {
		this.breadcrumbs = FolderBreadcrumbs(this.data.folder.id, this.folders).map(
			(folderId) => this.folders.find((folder) => folder.id === folderId),
		);
	}

	cancelModal(): void {
		this.dialogRef.close();
	}

	deleteFolder(): void {
		const data: FolderDialogClose = this.data.folder;
		this.dialogRef.close(data);
	}
}
